module.exports = __webpack_public_path__ + "fonts/AkzidenzGroteskPro-Bold.f3d473df.woff";